export const LoginSteps = {
  default: 1,
  otp: 2,
  contactSupport: 3,
  changeNumber: 4,
  otpChangeNumber: 5,
  changeDevice: 6,
  otpChangeDevice: 7,
  calculator: 8,
} as const;
